import {SearchTermService} from "../../ui/services/search.term.service";

export interface FilterMetadata{
	count:number;
}

import { Pipe, PipeTransform } from '@angular/core';

/**
 * @ngModule RISCommonModule
 * @description
 * Filters a given array of items(objects) by a given key property.
 * **Also returns the amout of filtered (included) items**
 * @param items the array of objects to filter:
 *    **if omitted**: returns an empty array.<br>
 * @param searchText the string that is searched for containment in the object specified key (see property param).
 *   **omitted**: return an empty array or all the items in the array based on the isReturnAllOnEmptySearch param value.<br>
 * @param property the name of the object property that we want to filter the collection by its value
 *    **This property must  be specified and must be one of the string properties of the object that represents**
 *     **an element of the input array**.<br>
 * @param filterMetadata an object with property named count.
 *  - **This object is used to return to the client code the count of filtered(included) items in the result**.<br>
 * @param isReturnAllOnEmptySearch an optional parameter that in case of an empty search string specifies what is the
 *  returned array
 * - **omitted**: return the input array with all its items.<br>
 * - **if true**: (the default value) return the input array with all its items.<br>
 * - **if negative**: return an empty array.<br>
 * @param isReturnAllOnEmptySearch an optional parameter that specifies whether checkMatch method of SearchTermService
 * service is used to filter the items (defaults to true), Otherwise contains search type is used<br>
 * @returns An array of the filterd items
 * **the whole input array might be returned dependeng on the arguments values**.
 * **an empty array might be returned dependeng on the arguments values**.
 * @example -
 * 1.in the using component define as a class field a metadata object of type FilterMetadata and init its count property:
 *   public filterMetadata:FilterMetadata = { count: 0 };
 * 2.in the component template
 * <div *ngFor="let categoryWorklistItem of selectedCategory?.workListsNavIcons |cpFilterWithCount:searchString:'worklistTitle':filterMetadata ;">
 */
@Pipe({
	name: 'cpFilterWithCount',
	pure: true
})
export class FilterWithCountPipe implements PipeTransform {

	constructor(private searchTermService:SearchTermService) {

	}

	transform(items: any[], searchText: string,property: string, filterMetadata: FilterMetadata,isReturnAllOnEmptySearch:boolean=true,
		isCheckMatchFilteration:boolean=true): any[] {
		if (!items){
			return [];
		}
		if (!searchText) {
			if (isReturnAllOnEmptySearch){
				filterMetadata.count = items.length;
				return items;
			}else{
				filterMetadata.count=0;
				return [];
			}
		}
		searchText = searchText.toLowerCase();
		let filteredItems = items.filter( it => {
			let stringToCheck = it[property].toLocaleLowerCase();
			if (isReturnAllOnEmptySearch){
				return this.searchTermService.checkMatch(stringToCheck,searchText);
			}else{
				return stringToCheck.includes(searchText);
			}
		});
		filterMetadata.count = filteredItems.length;
		return filteredItems;

	}

}

